(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bodylove-product"] && !Shopify.designMode) return;
  try {
    
function initBodyLoveProduct(scope){scope.querySelectorAll('[data-bl-product]').forEach(function(root){if(root.dataset.blReady)return;root.dataset.blReady='true';const slides=Array.from(root.querySelectorAll('[data-bl-slide]'));const buttons=Array.from(root.querySelectorAll('[data-bl-thumb]'));buttons.forEach(function(button){button.addEventListener('click',function(){const index=button.dataset.blThumb;slides.forEach(function(slide){slide.hidden=slide.dataset.blSlide!==index;slide.classList.toggle('is-active',!slide.hidden);if(slide.hidden)slide.querySelectorAll('video').forEach(function(v){v.pause();});});buttons.forEach(function(b){b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});});});});}
initBodyLoveProduct(document);document.addEventListener('shopify:section:load',function(e){initBodyLoveProduct(e.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bodylove-review-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-review-slider]').forEach((slider) => {
  if (slider.dataset.reviewSliderReady === 'true') return;
  slider.dataset.reviewSliderReady = 'true';
  const track = slider.querySelector('[data-review-track]');
  const cards = Array.from(track.children);
  const previous = slider.querySelector('[data-review-previous]');
  const next = slider.querySelector('[data-review-next]');
  let index = 0;
  let timer;
  const visibleCards = () => window.matchMedia('(max-width: 540px)').matches ? 1 : 2;
  const maxIndex = () => Math.max(0, cards.length - visibleCards());
  const render = () => {
    const card = cards[0];
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    index = Math.min(index, maxIndex());
    track.style.transform = 'translate3d(-' + distance * index + 'px,0,0)';
  };
  const move = (direction) => {
    const last = maxIndex();
    if (!last) return;
    index = direction === 'next' ? (index >= last ? 0 : index + 1) : (index <= 0 ? last : index - 1);
    render();
  };
  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (slider.dataset.autoplayEnabled !== 'true' || maxIndex() === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timer = window.setInterval(() => move('next'), Number(slider.dataset.autoplay) || 5000);
  };
  previous?.addEventListener('click', () => { move('previous'); start(); });
  next?.addEventListener('click', () => { move('next'); start(); });
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin', stop);
  slider.addEventListener('focusout', start);
  window.addEventListener('resize', render);
  render();
  start();
});

  } catch(e) { console.error(e); }
})();
})();
